import { useNavigate } from 'react-router-dom';
import { siteMeta } from '../../../mocks/site';

export default function HomeCta() {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden bg-primary-700">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/70 to-primary-700/40"></div>
      <div className="container-x relative z-10 flex flex-col items-center justify-between gap-6 py-12 text-center md:py-14 lg:flex-row lg:text-left">
        <div>
          <p className="text-sm font-medium tracking-widest text-accent-300">CONTRIBUTE</p>
          <h2 className="mt-2 font-display text-2xl font-black text-background-50 md:text-3xl">
            你手里也有压箱底的陈年旧瓜？
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-7 text-background-50/85">
            无论是尘封的老报道、泛黄的老照片，还是亲历当年的一手见闻，
            只要愿意考证来源，我们欢迎你把它写进故纸瓜档的档案里。
          </p>
        </div>
        <div className="flex shrink-0 flex-col items-center gap-3 sm:flex-row">
          <button
            onClick={() => navigate('/about#tougao')}
            className="inline-flex cursor-pointer whitespace-nowrap items-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-megaphone-line"></i>立即投稿爆料
          </button>
          <a
            href={`mailto:${siteMeta.email}`}
            className="inline-flex cursor-pointer whitespace-nowrap items-center gap-2 rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-mail-send-line"></i>邮件联系
          </a>
        </div>
      </div>
    </section>
  );
}